import PublicApiConsoleContainer from 'src/pages/PublicApiConsoleContainer';
import 'src/scss/style.scss';

const App = () => <PublicApiConsoleContainer />;

export default App;
